import type { ArchiveState } from './types';

/** Store mounts the archived loans selectors read from. */
export interface LoansArchiveStore {
  loans: {
    archive: ArchiveState;
  };
}

/** Store mounts the archived retainers selectors read from. */
export interface RetainersArchiveStore {
  retainers: {
    archive: ArchiveState;
  };
}

export const selectArchivedLoans = (store: LoansArchiveStore) => store.loans.archive.archivedItems;

export const selectSearchArchivedLoansLoading = (store: LoansArchiveStore) =>
  store.loans.archive.requestStatus === 'pending';

/**
 * Whether the last search failed. Distinguishes an empty list nobody answered
 * from one the server answered with nothing.
 */
export const selectSearchArchivedLoansFailed = (store: LoansArchiveStore) =>
  store.loans.archive.requestStatus === 'error';

/** Number of the newest search sent — see `ArchiveState.searchSeq`. */
export const selectArchivedLoansSearchSeq = (store: LoansArchiveStore) =>
  store.loans.archive.searchSeq;

/** Id of the loan whose restore is in flight, `null` when none is. */
export const selectRestoringLoanId = (store: LoansArchiveStore) => store.loans.archive.restoringId;

/** The finished restore the page has yet to announce, `null` once it has. */
export const selectRestoreLoanOutcome = (store: LoansArchiveStore) =>
  store.loans.archive.restoreOutcome;

export const selectArchivedProjects = (store: RetainersArchiveStore) =>
  store.retainers.archive.archivedItems;

export const selectSearchArchivedRetainersLoading = (store: RetainersArchiveStore) =>
  store.retainers.archive.requestStatus === 'pending';

/** Retainers counterpart of {@link selectSearchArchivedLoansFailed}. */
export const selectSearchArchivedRetainersFailed = (store: RetainersArchiveStore) =>
  store.retainers.archive.requestStatus === 'error';

/** Number of the newest search sent — see `ArchiveState.searchSeq`. */
export const selectArchivedRetainersSearchSeq = (store: RetainersArchiveStore) =>
  store.retainers.archive.searchSeq;

/** Id of the project whose restore is in flight, `null` when none is. */
export const selectRestoringProjectId = (store: RetainersArchiveStore) =>
  store.retainers.archive.restoringId;

/** The finished restore the page has yet to announce, `null` once it has. */
export const selectRestoreProjectOutcome = (store: RetainersArchiveStore) =>
  store.retainers.archive.restoreOutcome;
